
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-chibi-maker",
      function () {
        return require("private-next-pages/ai-chibi-maker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-chibi-maker"])
      });
    }
  